<script setup>
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();

const languages = [
  { code: 'en', name: 'English' },
  { code: 'ms', name: 'Bahasa Malaysia' },
  { code: 'zh', name: '中文' }
];
</script>

<template>
  <div class="relative group">
    <button class="flex items-center gap-2 px-4 py-2 text-sm rounded-full border hover:bg-gray-50">
      <span v-if="locale === 'en'">🇬🇧</span>
      <span v-else-if="locale === 'ms'">🇲🇾</span>
      <span v-else-if="locale === 'zh'">🇨🇳</span>
      <span class="hidden md:inline">{{ languages.find(lang => lang.code === locale)?.name }}</span>
    </button>
    
    <div class="absolute right-0 mt-2 py-2 w-48 bg-white rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
      <button 
        v-for="lang in languages" 
        :key="lang.code"
        @click="locale = lang.code"
        class="w-full px-4 py-2 text-left text-sm hover:bg-gray-50"
        :class="{ 'font-medium': locale === lang.code }"
      >
        {{ lang.name }}
      </button>
    </div>
  </div>
</template>